import OadpEntityPagination from './oadp-entity-pagination';
export default OadpEntityPagination;
